const supportedLocales = ['es', 'pt', 'de'];

module.exports = { supportedLocales };
